import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RouterService from '@ember/routing/router-service';
import type RfiService from 'scaleflow/services/rfi';

class DataRfiRoute extends Route {
  @service declare betaToggle: BetaToggleService;
  @service declare router: RouterService;
  @service declare rfi: RfiService;

  // Never rejects: the service reports a failure through `rfi.errorMessage`.
  async model() {
    await this.rfi.load();
  }

  // Checked after the model, not in `beforeModel`: on a hard reload PostHog's
  // flags are still empty at that point and the guard would bounce to home.
  afterModel() {
    if (!this.betaToggle.isXrayCustomer) this.router.transitionTo('home');
  }
}

export default instrumentRoutePerformance(DataRfiRoute);
